import { GET_PERFORMANCE_VENUE } from "../actions/PerformanceVenueTypes";
const initialState = {
  data: [],
  page: 1,
  total: 0,
  totalPages: 0,
  isLoading: true,
};
const initial = false;
function PerformanceVenueReducer(state = initialState, actions) {
  if (actions.type === GET_PERFORMANCE_VENUE) {
    return {
      ...state,
      ...actions.payload,
    };
  }
  if (
    actions.type === "LOADING" &&
    actions.payload.action_model === GET_PERFORMANCE_VENUE
  ) {
    return {
      ...state,
      isLoading: actions.payload.loading,
    };
  }
  return state;
}

export { PerformanceVenueReducer };
